var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"white"},[_c('Header'),_c('v-content',[(_vm.loader)?_c('v-progress-linear',{attrs:{"indeterminate":_vm.loader}}):_vm._e(),_c('router-view')],1),(_vm.showNavigation)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }